<div *ngIf="costs" class="inner-content">
  <p class="SCWEB-header-text">Your receipt</p>
  <div id="receipt-wrapper">
    <invoice-receipt [costs]="costs" [serviceTypeList]="serviceTypeList" [refunded]="refunded">
    </invoice-receipt>
  </div>
</div>